import { useEffect, useState } from "react";
import { Users } from "lucide-react";
import { api } from "@/lib/api";

export default function StatusPill() {
  const [s, setS] = useState(null);
  useEffect(() => {
    const load = () => api.get("/server-status").then((r) => setS(r.data)).catch(() => setS({ online: false }));
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);
  const online = s?.online;

  return (
    <div className="steel-panel chamfer inline-block" style={{ "--c": "12px" }} data-testid="site-status">
      <div className="steel-inner chamfer flex items-center gap-4 px-6 py-2.5" style={{ "--c": "10.5px" }}>
        <span className="flex items-center gap-2 text-sm font-semibold" data-testid="site-status-badge">
          <span className={`w-2.5 h-2.5 rounded-full ${s === null ? "bg-slate-500" : online ? "bg-sky-400 shadow-[0_0_10px_#38bdf8] animate-pulse" : "bg-red-500"}`} />
          <span className={online ? "text-sky-200" : s === null ? "text-slate-400" : "text-red-300"}>
            {s === null ? "Sprawdzanie..." : online ? "Serwer online" : "Serwer offline"}
          </span>
        </span>
        {online && s.players != null && (
          <span className="flex items-center gap-2 text-sm text-slate-300 border-l border-slate-600/50 pl-4" data-testid="site-players">
            <Users size={15} className="text-amber-400" />
            <span className="font-mono text-amber-200" data-testid="site-players-count">{s.players}</span> online
          </span>
        )}
      </div>
    </div>
  );
}
